
module.exports = {
  brandingName: 'Innbucks (test)',
  privacyPolicyURL: 'https://wallet.innbucks.co.zw/pp.html',
  termsAndConditionsURL: 'https://wallet.innbucks.co.zw/tc.html',
};
